import React, { PureComponent, Fragment } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlineRounded';
import { SlideTransition } from '../../../components/Transition/Transition';
import IconToast from '../../../components/NewToast';
import AladdinHint from '../../../components/AladdinHint/AladdinHint';
import LoadingBackdrop from '../../../components/LoadingBackdrop/LoadingBackdrop';
import TrackOffDialog from '../../../components/ClientEntry/TrackOffDialog/TrackOffDialog';
import { getClientById } from '../../../store/client/api';

class ShareFromView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      deleteTarget: null,
      lastDeletedReceiverType: '',
      fetchingClient: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.completeShareDelete = this.completeShareDelete.bind(this);
    this.openTrackOffThenConfirm = this.openTrackOffThenConfirm.bind(this);
    this.onClickTrash = this.onClickTrash.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { intl } = this.props;
    if (nextProps.deleteFromPhase === true) {
      this.props.getShareFromData();
      this.props.getUser();
      const toastId =
        this.state.lastDeletedReceiverType === 'Advisor'
          ? 'share-from-deleted-adviser'
          : 'share-from-deleted-other';
      toast.info(IconToast('info', intl.formatMessage({ id: toastId })), { className: 'new-toast' });
    }
    if (nextProps.getDocPhase === false && this.props.getDocPhase !== false) {
      toast.info(IconToast('error', nextProps.resMessage), { className: 'new-toast' });
    }
    if (nextProps.getDocPhase === true && this.props.getDocPhase !== true) {
      let sharePolicyData = {};
      sharePolicyData.portfolio1 = _.get(nextProps, 'portfolio1');
      sharePolicyData.categories1 = _.get(nextProps, 'categories1');
      sharePolicyData.forexCurrency1 = _.get(nextProps, 'forexCurrency1');
      sharePolicyData.shareType = _.get(nextProps, 'shareType');
      sharePolicyData.adviserInfo = _.get(nextProps, 'adviserInfo');
      this.props.history.push({
        pathname: '/share_link_view',
        state: { sharePolicyData }
      });
    }
  }

  openModal(data) {
    this.setState({
      deleteTarget: data,
      modalIsOpen: true
    });
  }

  closeModal() {
    this.setState({ modalIsOpen: false, deleteTarget: null });
  }

  completeShareDelete(share) {
    if (!share || !share._id) {
      this.closeModal();
      return;
    }
    this.props.deleteShareFromList(share._id);
    this.setState({
      modalIsOpen: false,
      deleteTarget: null,
      lastDeletedReceiverType: share.receiverType
    });
  }

  // Trash: close an open case first, then confirm disconnect. enableTracking is
  // rejected after the share is removed, so tracking must be updated while connected.
  async openTrackOffThenConfirm(share) {
    const { intl, toggleDialog } = this.props;
    const clientId = _.get(share, 'senderId._id');
    this.setState({ modalIsOpen: false, deleteTarget: share, fetchingClient: true });
    try {
      const payload = await getClientById(clientId);
      const client = _.get(payload, 'client');
      const trackingActive = _.get(client, 'trackingId.isActive') === true;
      const canCloseTracking = trackingActive && _.get(client, 'trackingId._id') && _.get(client, 'factsheetId._id');

      if (!payload || payload.success === false || !client) {
        toast.info(IconToast('error', intl.formatMessage({ id: 'share-from-tracking-load-failed' })), {
          className: 'new-toast'
        });
        this.setState({ deleteTarget: null });
        return;
      }

      if (!canCloseTracking) {
        this.openModal(share);
        return;
      }

      toggleDialog('trackOff', {
        client,
        businessVol: _.get(client, 'trackingId.businessVol', null),
        met: _.get(client, 'trackingId.met', 0),
        onSuccess: () => this.openModal(share)
      });
    } catch (error) {
      toast.info(IconToast('error', intl.formatMessage({ id: 'share-from-tracking-load-failed' })), {
        className: 'new-toast'
      });
      this.setState({ deleteTarget: null });
    } finally {
      this.setState({ fetchingClient: false });
    }
  }

  onClickTrash(data) {
    if (data && data.receiverType === 'Advisor') {
      this.openTrackOffThenConfirm(data);
      return;
    }
    this.openModal(data);
  }

  delete() {
    this.completeShareDelete(this.state.deleteTarget);
  }
  // To show the policy of share from
  viewSharedPolicy(val) {
    const { getShareMeDocuments } = this.props;
    var formData = {};
    formData.id = val._id;
    this.setState({ selectedID: val.senderId._id, shareID: val._id });
    getShareMeDocuments(formData);
  }

  render() {
    const { shareFromData, intl, userDetails } = this.props;
    const deleteTarget = this.state.deleteTarget;
    const isAdviserShare = deleteTarget && deleteTarget.receiverType === 'Advisor';
    const senderEmail = _.get(deleteTarget, 'senderId.email', '');
    // var user = this.props.userDetails;
    // let margin = user.userType === 'User' ? '95px' : '61px';
    return (
      <Fragment>
        {this.props.deleteFromPhase === 'loading' || this.state.fetchingClient ? <LoadingBackdrop open={true} /> : null}
        <TrackOffDialog />
        <div id="wrapper" className="share__page">
          <div className="shareContainer" style={{ marginTop: userDetails.userType === 'User' ? '0px' : '50px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                width: '100%',
                borderBottom: '1px solid #dddddd'
              }}
            >
              <div style={{ marginTop: '5px', marginBottom: '8px' }}>
                <AladdinHint title={intl.formatMessage({ id: 'share-from-hints' })} />
              </div>
            </div>
          </div>
          <div>
            <div>
              <div style={{ paddingBottom: 'calc(55px + var(--bottom-padding))' }}>
                <div className="JStableOuter share">
                  <table className="share-table">
                    <thead>
                      <tr className="shareDiv">
                        {/*<th className="share-from-table-view-col">{intl.formatMessage({ id: 'View' })}</th>*/}
                        <th className="share-from-table-email-col">{intl.formatMessage({ id: 'Email' })} </th>
                        <th className="share-from-table-type-col">{intl.formatMessage({ id: 'Type' })}</th>
                        <th className="share-from-table-delete-col">{intl.formatMessage({ id: 'Delete' })}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shareFromData &&
                        shareFromData.length > 0 &&
                        shareFromData.map((val, index) => {
                          if (!val.senderId) {
                            return '';
                          }
                          var senderInfo = val.senderId;
                          return (
                            <tr key={index} className="shareDiv">
                              {/*<td className="view-style share-from-table-view-col">*/}
                              {/*  <img*/}
                              {/*    alt=""*/}
                              {/*    className="forwardArrow"*/}
                              {/*    src="img/view.png"*/}
                              {/*    onClick={this.viewSharedPolicy.bind(this, val)}*/}
                              {/*  />*/}
                              {/*</td>*/}
                              <td className="share-from-table-email-col">{senderInfo.email}</td>
                              <td className="share-from-table-type-col">
                                {val.receiverType === 'Advisor'
                                  ? intl.formatMessage({ id: 'Adviser' })
                                  : val.receiverType === 'User'
                                  ? intl.formatMessage({ id: 'Reference' })
                                  : val.receiverType === 'Emergency'
                                  ? intl.formatMessage({ id: 'Emergency' })
                                  : intl.formatMessage({
                                      id: 'Family'
                                    })}
                              </td>
                              <td className="share-from-table-delete-col">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  aria-label="delete"
                                  onClick={this.onClickTrash.bind(this, val)}
                                >
                                  <DeleteOutlineIcon />
                                </IconButton>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div>
                  <Dialog
                    open={this.state.modalIsOpen}
                    onClose={this.closeModal}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    fullWidth={true}
                    slots={{
                      transition: SlideTransition
                    }}
                  >
                    <DialogTitle id="alert-dialog-slide-title">
                      {intl.formatMessage({
                        id: isAdviserShare ? 'share-from-disconnect-title' : 'Delete'
                      })}
                    </DialogTitle>
                    <DialogContent>
                      <Typography style={{ whiteSpace: 'pre-wrap', fontSize: '15px', lineHeight: 1.55 }}>
                        {intl.formatMessage(
                          {
                            id: isAdviserShare
                              ? 'share-from-disconnect-adviser-content'
                              : 'share-from-delete-other-content'
                          },
                          { email: senderEmail }
                        )}
                      </Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.closeModal} color="primary">
                        {intl.formatMessage({ id: 'Cancel' })}
                      </Button>
                      <Button onClick={this.delete.bind(this)} color="primary">
                        {intl.formatMessage({ id: 'OK' })}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ShareFromView;
